import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import TaskIcon from 'components/tasks/task_icon';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { faShareFromSquare } from '@fortawesome/pro-light-svg-icons';

class TasksCompleted extends React.Component {
  static propTypes = {
    editingTask: PropTypes.object.isRequired,
    followUpTask: PropTypes.object.isRequired,
    showFollowUp: PropTypes.bool.isRequired
  }

  taskType(type) {
    switch (type) {
    case 1:
      return 'call';
    case 2:
      return 'email';
    default:
      return 'other';
    }
  }

  render() {
    const { editingTask, followUpTask, showFollowUp } = this.props;

    return (
      <div className="mb-1">
        <div className="text-success d-flex align-items-center mb-2 gap-2">
          <FontAwesomeIcon icon={faCircleCheck} size="2x" />
          <div> Task Completed </div>
        </div>
        <div className="d-flex w-100 mb-2">
          <div className="border bg-light w-100 mb-1 p-2 ps-3">
            <div className="text-decoration-line-through">
              {editingTask.title}
            </div>
          </div>
        </div>
        {showFollowUp &&
          <>
            <div className="d-flex align-items-center mb-2 gap-2 text-accent">
              <FontAwesomeIcon icon={faShareFromSquare} size="2x" />
              <div className="ms-2"> Follow-up Created </div>
            </div>
            <div className="d-flex mb-2">
              <div className="d-flex border w-100 p-2 ps-3 align-items-center justify-content-between mb-1">
                <div className="task-title">
                  {followUpTask.title}
                </div>
                <div className="task-icon">
                  <TaskIcon size="xs" type={this.taskType(followUpTask.taskType)}/>
                </div>
              </div>
            </div>
          </>
        }
      </div>
    );
  }
}

export default TasksCompleted;
